type AppPageShellProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
  maxWidth?: "md" | "lg" | "xl";
};

const widthClass = {
  md: "max-w-3xl",
  lg: "max-w-4xl",
  xl: "max-w-6xl",
} as const;

export function AppPageShell({
  title,
  description,
  children,
  maxWidth = "lg",
}: AppPageShellProps) {
  return (
    <div className="min-h-screen bg-[#f7f8fa] pb-28 md:pb-12">
      <div className={`${widthClass[maxWidth]} mx-auto px-4 sm:px-6 py-10`}>
        <header className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 tracking-tight">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm sm:text-base text-gray-600 leading-relaxed">
              {description}
            </p>
          )}
        </header>
        {children}
      </div>
    </div>
  );
}
